// Navbar + Sidebar
const en = {
  appName: 'Inventory',
  dashboard: 'Dashboard',
  equipment: 'Equipment',
  orders: 'Orders',
  parts: 'Parts',
  stockMovements: 'Stock Movements',
  templates: 'Templates',
  componentStock: 'Component Stock',
  repairs: 'Repairs',
  productionTasks: 'To Produce',
  vacations: 'Vacation',
  customers: 'Customers',
  dealers: 'Dealers',
  devices: 'Devices',
  users: 'Users',
  searchEquipment: 'Search equipment...',
  searchParts: 'Search parts...',
  searchOrders: 'Search orders...',
  searchStockMovements: 'Search stock movements...',
  searchTemplates: 'Search templates...',
  searchComponentStock: 'Search component stock...',
  searchRepairs: 'Search repairs...',
  searchCustomers: 'Search customers...',
  searchDealers: 'Search dealers...',
  searchDevices: 'Search serial, brand, model...',
  searchUsers: 'Search users...',
  searchDefault: 'Search... (Ctrl+K)',
  profileSettings: 'Profile Settings',
  logout: 'Logout',
  user: 'User',
  admin: 'Admin',
  switchToEnglish: 'Switch to English',
  switchToGerman: 'Auf Deutsch umschalten',
};

const de = {
  appName: 'Inventar',
  dashboard: 'Übersicht',
  equipment: 'Ausrüstung',
  orders: 'Bestellungen',
  parts: 'Teile',
  stockMovements: 'Lagerbewegungen',
  templates: 'Vorlagen',
  componentStock: 'Komponentenlager',
  repairs: 'Reparaturen',
  productionTasks: 'Zu produzieren',
  vacations: 'Ferien',
  customers: 'Kunden',
  dealers: 'Händler',
  devices: 'Geräte',
  users: 'Benutzer',
  searchEquipment: 'Ausrüstung suchen...',
  searchParts: 'Teile suchen...',
  searchOrders: 'Bestellungen suchen...',
  searchStockMovements: 'Lagerbewegungen suchen...',
  searchTemplates: 'Vorlagen suchen...',
  searchComponentStock: 'Komponentenlager suchen...',
  searchRepairs: 'Reparaturen suchen...',
  searchCustomers: 'Kunden suchen...',
  searchDealers: 'Händler suchen...',
  searchDevices: 'Seriennummer, Marke, Modell suchen...',
  searchUsers: 'Benutzer suchen...',
  searchDefault: 'Suchen... (Strg+K)',
  profileSettings: 'Profileinstellungen',
  logout: 'Abmelden',
  user: 'Benutzer',
  admin: 'Administrator',
  switchToEnglish: 'Switch to English',
  switchToGerman: 'Auf Deutsch umschalten',
};

const nav = { en, de };
export default nav;
